import React from 'react';
import { Badge } from '../types';
import BadgeCard from './BadgeCard';
import EmptyState from '../../../UI/EmptyState';
import styles from '../../../../styles/BadgesAndAchievements.module.css';

interface BadgeListProps {
  badges: Badge[];
  onEdit: (badge: Badge) => void;
  onDelete: (badge: Badge) => void;
  onCreateBadge: () => void;
  isWorkMode?: boolean;
  currentUserId?: string;
  userBadges?: any[];
}

const BadgeList: React.FC<BadgeListProps> = ({ badges, onEdit, onDelete, onCreateBadge, isWorkMode = false, currentUserId, userBadges = [] }) => {
  // Get userBadge data for personal mode
  const getUserBadgeData = (badgeId: string) => {
    if (isWorkMode) return undefined;
    return userBadges.find((ub: any) => ub.badge?.id === badgeId);
  };

  if (badges.length === 0) {
    return (
      <EmptyState
        image="/images/notasks.png"
        title="No badges found"
        description={isWorkMode ? "Create your first badge to get started with achievements" : "You haven't earned any badges yet"}
        action={isWorkMode ? {
          label: "Create Badge",
          onClick: onCreateBadge
        } : undefined}
      />
    );
  }

  return (
    <div className={`${styles.badgeList} ${!isWorkMode ? styles.personalModeGrid : ''}`}>
      {badges.map((badge) => {
        const userBadgeData = getUserBadgeData(badge.id);
        return (
          <BadgeCard
            key={badge.id}
            badge={badge}
            onEdit={onEdit}
            onDelete={onDelete}
            currentUserId={currentUserId}
            isWorkMode={isWorkMode}
            userBadge={userBadgeData}
          />
        );
      })}
    </div>
  );
};

export default BadgeList;

